import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { SidenavUtils } from '@/common/utils/SideNavUtils';

const acSideNav = {
  id: 'ac',
  displayName: 'Audit & Compliance',
  role: 'AC_VIEW',
  shortName: 'A & C',
  icon: far.faCabinetFiling,
  precedence: 999,
  route: '',
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('ac'),

    // Software Section
    {
      id: 'acMenu',
      displayName: 'Software',
      role: 'AC_VIEW',
      icon: fas.faDesktop,
      precedence: 1,
      children: [
        { id: 'acSection', displayName: 'Sections', role: 'AC_SECTION_VIEW', icon: fas.faObjectGroup, route: '/ac/section', precedence: 2 },
        { id: 'acRqmt', displayName: 'Requirements', role: 'AC_RQMT_VIEW', icon: fas.faInfoCircle, route: '/ac/rqmt', precedence: 3 },
        { id: 'acRelease', displayName: 'Releases', role: 'AC_RELEASE_VIEW', icon: fas.faPlusSquare, route: '/ac/release', precedence: 4 },
        { id: 'acReleaseNote', displayName: 'Release Notes', role: 'AC_RELEASE_NOTE_VIEW', icon: fas.faStickyNote, route: '/ac/release-note', precedence: 5 },
        { id: 'acRevision', displayName: 'Revisions', role: 'AC_REVISION_VIEW', icon: fas.faRocket, route: '/ac/revision', precedence: 6 }
      ]
    },

    // Testing Section
    {
      id: 'acTestMenu',
      displayName: 'Testing',
      role: 'AC_TEST_VIEW',
      icon: fas.faTachometer,
      precedence: 7,
      children: [
        { id: 'acTestDashboard', displayName: 'Test Dashboard', role: 'AC_VIEW', icon: fas.faTachometer, route: 'ac/dashboard/test',precedence: 8 },
        { id: 'acSuite', displayName: 'Suites', role: 'AC_SUITE_VIEW', icon: fas.faTachometer, route: '/ac/suite', precedence: 9 },
        { id: 'acTest', displayName: 'Tests', role: 'AC_TEST_VIEW', icon: fas.faTachometer, route: '/ac/test', precedence: 10 },
        { id: 'acBlock', displayName: 'Blocks', role: 'AC_BLOCK_VIEW', icon: fas.faTachometer, route: '/ac/block', precedence: 11 },
        { id: 'acTestStepDataSet', displayName: 'Test Step Data Sets', role: 'AC_TEST_STEP_DATA_SET_VIEW', icon: fas.faTachometer, route: '/ac/test-step-data-set', precedence: 12 },
        { id: 'acDataSet', displayName: 'Data Sets', role: 'AC_DATA_SET_VIEW', icon: fas.faTachometer, route: '/ac/data-set', precedence: 13 },
        { id: 'acVar', displayName: 'Variables', role: 'AC_VAR_VIEW', icon: fas.faTachometer, route: '/ac/var', precedence: 14 },
        { id: 'acDefect', displayName: 'Defects', role: 'AC_DEFECT_VIEW', icon: fas.faBug, route: '/ac/defect', precedence: 15 }
      ]
    },

    // Common Menus
    ...SidenavUtils.commonMenus('ac')
  ]
};

export default acSideNav;
